import React from 'react';
import '../styles/SocialShare.css';

const SocialShare = ({ 
  url, 
  title = "聯漢室內設計工作室 - 專業室內設計服務",
  description = "專業室內設計團隊，提供台東、高雄地區住宅設計、商業空間設計、舊屋翻新等服務",
  image = "http://www.lan-hung560.com.tw/images/logo.png"
}) => {
  
  // 安全地獲取當前URL
  const currentUrl = url || (typeof window !== 'undefined' ? window.location.href : 'http://www.lan-hung560.com.tw');
  
  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`,
    line: `https://line.me/R/msg/text/?${encodeURIComponent(title + ' ' + currentUrl)}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(currentUrl)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`,
    email: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(description + '\n\n' + currentUrl)}`
  };

  const handleShare = (platform, link) => {
    // 追蹤分享事件
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'share', {
        method: platform,
        content_type: 'website',
        item_id: currentUrl
      });
    }

    // 開啟分享視窗
    window.open(
      link,
      'share-dialog',
      'width=600,height=400,location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1'
    );
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      alert('連結已複製到剪貼簿！');
      
      // 追蹤複製事件
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'share', {
          method: 'copy_link',
          content_type: 'website',
          item_id: currentUrl
        });
      }
    } catch (err) {
      console.error('複製失敗:', err);
    }
  };

  return (
    <div className="social-share">
      <h4 className="social-share-title">分享到社群媒體</h4>
      <div className="social-share-buttons">
        <button 
          className="social-btn facebook"
          onClick={() => handleShare('facebook', shareLinks.facebook)}
          aria-label="分享到Facebook"
        >
          <i className="fab fa-facebook-f"></i>
          <span>Facebook</span>
        </button>
        
        <button 
          className="social-btn line"
          onClick={() => handleShare('line', shareLinks.line)}
          aria-label="分享到LINE"
        >
          <i className="fab fa-line"></i>
          <span>LINE</span>
        </button>
        
        <button 
          className="social-btn twitter"
          onClick={() => handleShare('twitter', shareLinks.twitter)}
          aria-label="分享到Twitter"
        >
          <i className="fab fa-twitter"></i>
          <span>Twitter</span>
        </button>
        
        <button 
          className="social-btn linkedin"
          onClick={() => handleShare('linkedin', shareLinks.linkedin)}
          aria-label="分享到LinkedIn"
        >
          <i className="fab fa-linkedin-in"></i>
          <span>LinkedIn</span>
        </button>
        
        <button 
          className="social-btn email"
          onClick={() => handleShare('email', shareLinks.email)}
          aria-label="透過Email分享"
        >
          <i className="fas fa-envelope"></i>
          <span>Email</span>
        </button>
        
        <button 
          className="social-btn copy"
          onClick={copyToClipboard}
          aria-label="複製連結"
        >
          <i className="fas fa-link"></i>
          <span>複製連結</span>
        </button>
      </div>
    </div>
  );
};

export default SocialShare; 